import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import NumberFormat from 'react-number-format';

const EditPhoneHome = (props) => {
  const [disabled, setDisabled] = useState(true);

  const handleValueChange = () => {
    setDisabled(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="md">
      <ModalHeader toggle={props.toggle}>
        Edit Work Number
        <button type="button" className="close" onClick={props.toggle} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Input
          type="tel"
          name="work-number"
          id="workNumber"
          label="Work Number"
          tag={NumberFormat}
          format="(###) ###-####"
          defaultValue="5551234567"
          onChange={handleValueChange}
        />
        <FormGroup className="mb-3" check>
          <Input
            type="checkbox"
            name="check"
            id="Check"
            onChange={handleValueChange}
          />
          <Label check for="Check">
            Set as primary number
          </Label>
        </FormGroup>

        <Button color="primary" className="w-100" disabled={disabled}>Save</Button>

      </ModalBody>
    </Modal>
  );
};

EditPhoneHome.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EditPhoneHome;
